import { Component, OnInit, Input, OnChanges, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-cart-steps',
  templateUrl: './cart-steps.component.html',
  styleUrls: ['./cart-steps.component.scss'],
})
export class CartStepsComponent implements OnInit, OnChanges {
  @Input() public step = 1;
  @Input() public steps;

  constructor() {}

  ngOnInit() {
    this.steps = this.steps ? this.steps : [];
  }

  ngOnChanges() {
    if (this.steps.length === 0) {
      console.error('Steps array cant be empty');
    } else {
      if (this.step < 1) {
        this.step = 1;
        console.error(`Step can be between 1 and ${this.steps.length}`);
      }
      if (this.step > this.steps.length) {
        this.step = this.steps.length;
        console.error(`Step can be between 1 and ${this.steps.length}`);
      }
    }
  }
}
